export default function (existingDealer, existingBranch, getDealersList, addVmcAccount, $state, toaster, close, currentUser, franchiseList, referenceCodeGenerator, getAccountGroups) {
    const vm = this;

    vm.model = {
        accountNumber: ''
    };
    vm.form = null;
    vm.franchises = [];
    vm.franchise = null;
    vm.currentUser = null;
    vm.accountGroups = [];
    vm.selectedAccountGroup = null;

    vm.save = add;
    vm.closeModal = close;

    /* --- */

    currentUser()
    .then(result => {
        vm.currentUser = result;
    });

    getNewReferenceCode(); // FL: This is horrible - but it works so leave for now :(
    getFranchises();

    getAccountGroups()
    .then(groups => {
        vm.accountGroups = groups;
    });

    /* --- */

    function getNewReferenceCode() {
        referenceCodeGenerator().then(data => {
            vm.model.accountNumber = data.result;
        });
    }

    function add() {
        if (!vm.currentUser.isAdmin && !vm.currentUser.isAccountAdmin) {
            return;
        }

        if (vm.form.$invalid) {
            return;
        }

        if (vm.franchise !== null) {
            vm.model.franchiseId = vm.franchise.id;
        }

        if (vm.selectedAccountGroup != null) {
            vm.model.groupId = vm.selectedAccountGroup.id;
        }

        addVmcAccount(vm.model)
        .then(() => {
            toaster.pop('success', 'The account was successfully created');
            close();
        })
        .catch(error => {
            toaster.pop('error', error.data);
        });
    }

    function getFranchises() {
        franchiseList().then(data => {
            vm.franchises = data;
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/dealer/controllers/addVmcAccount/addVmcAccountCtrl.js